import { componentStyleWithExtend } from '@/styling/util/component-style.ts';
import type { PanelDesignTokens } from '@primeuix/themes/types/panel';

export const panelStyle: ReturnType<typeof componentStyleWithExtend<PanelDesignTokens>> =
    componentStyleWithExtend<PanelDesignTokens>({
        extend: {
            root: {
                headerBorderBottom: '1px solid {content.border.color}',
            },
        },
        style: {
            header: {
                background: '{primitive.gray.50}',
            },
            content: {
                padding: '1rem',
            },
        },
        css: ({ dt }) => `
        .p-panel-header {
            border-bottom: ${String(dt('panel.header.border.bottom'))};
        }
    `,
    });
